/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React, { createRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography, Modal, ExpandCollapse } from '@telus-uds/components-web';

import addDays from 'date-fns/addDays';
import request, { apiHost } from '../utils/request';
import useOrderPdf from '../hooks/useOrderPdf';
import { VulcanFormField as FormField } from './vulcanFormsCoreAdapters/fieldRegistry';
import VulcanFormStepRunner from './VulcanFormStepRunner';
import FormsCorePreviewBoundary from './vulcanFormsCoreAdapters/FormsCorePreviewBoundary';
import { computeIsThisVulcanOrder } from './vulcanFormsCoreAdapters/businessRulesAdapter';
import { buildEngineFieldBag } from './vulcanFormsCoreAdapters/buildEngineFieldBag';
import ValidateLoader from '../UI/validateLoader';
import ProgressBar from '../design/progressBar';
import UserDetailsForm from './userDetailsForm';
import EquipmentSectionForm from './vulcanHelpers/tsbSection/equipmentSectionFormVulcan';
import Note from '../note';
import RepeatedForm from './repeatedForm';
import { getFieldChecked, numberOfSelectedItems } from './utils';
import { getFormData, isRelatedFieldExisted } from './formStepFMVulcanUtils';
import { normalizeEquipmentGroupSection } from './formStepUtils';
import { useTranslationsContext } from '../context/TranslationsContext';
import { Box } from '../design/css';
import { useLocaleContext } from '../context/LocaleContext';
import { GroupTitle, GroupWrapper } from './css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import {
  roleLabels,
  localeFrench,
  stepKeyMain,
  fieldActivationLanguage,
  categoryVulcan,
  vulcanForm,
  isVulcanLandingPage,
  fieldPermitNumberUserAccountDetailVulcan,
  fieldExpirationKeyVulcan,
  fieldsKeyLocalStorage,
  vulcanLandingPage,
  smokeDetectorWarningNoteVulcan,
  temperatureSensorFeeNote1Vulcan,
  temperatureSensorFeeNote2Vulcan,
  keyAdditionalEquipment,
  smokeFireDetectorVulcan,
  easyThreeYearSmokeFireDetectorVulcan,
  easyFiveYearSmokeFireDetectorVulcan,
  temperatureSensorVulcan,
  easyThreeYearTemperatureSensorVulcan,
  easyFiveYearTemperatureSensorVulcan,
  numberOfAccessPointsTotal,
  fieldNumberOfAccessPoints,
  regexBusinessInc,
  fieldAddProductVulcan,
  fieldProductVulcan,
  fieldWebFormOrderId,
  keyMonitorAdditionalEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyMonitorVulcan,
  keyProtectVulcan,
  fieldOrderIdTSB,
  fieldWirelinePreferedInstallDateVulcan,
  fieldSecondaryInstallDateVulcan,
  CONSTANT,
  fieldStoreCodeVulcan,
  fieldStoreCodeOutletVulcan,
  textNoteVUL,
  fieldServiceAddress,
  fieldRcidVulcan,
  fieldBanVulcan,
  fieldStreetNameVul,
  fieldStreetNumberVul,
  fieldCityVul,
  fieldPostalCodeVul,
  fieldProvinceVUL,
  fieldInstallationPreferredArrivalWindowVulcan,
  fieldCommercialPremise,
  isCouponBasedDiscountTSBField,
  productCatalog,
  smartCameraAdditionalEquipmentVulcan,
  tsbTerm,
  secureBusinessSectionsVulcan,
  monitorSectionsVulcan,
  protectSectionsVulcan,
  controlSectionsVulcan,
  smartCameraSectionsVulcan,
  tsb15SectionPriceKeys,
  fieldInstallationFeeAmount,
  fieldInstallationFeePaymentOption,
  installationFeePaymentOptions,
  secureBusinessPlanVulcan
} from '../utils/constant';
import {
  handleInstallationFeeDiscount,
  getTsb15AddOnEquipmentCount
} from './vulcanPricing/secureBusiness/secureBusiness';
import { secureBusinessOffersVulcan } from './vulcanPricing/secureBusiness/secureBusinessFieldNames';
import { localeFr, getPathVariables } from '../misc';
import {
  autoSelectAllAdvisories,
  permitNumbers
} from './vulcanHelpers/advisoriesHelpers';
import VulcanStatusBar from '../design/vulcanStatusBar';
import PrequalificationHelpers from './vulcanHelpers/prequalificationHelpers';
import CustomerHelpers from './vulcanHelpers/customerSection/customerHelpers';
import VulcanOrderSummary from './orderSummary/vulcanOrderSummary';
import FibreBusinessWifiHelpers from './vulcanHelpers/fibreBusinessWifiHelpers';
import { StoreCodeOptionsHelper } from './vulcanHelpers/storeCodeOptionsHelper';
import prequalificationSectionHelpers from './vulcanHelpers/tsbSection/prequalificationSectionHelpers';
import BusinessOptikTvHelpers from './vulcanHelpers/businessOptikTvHelpers';
import vulcanPricing from './vulcanPricing/vulcanPricing';
import { Error } from '../design/elements';
import additionalCustomerInformationHelpers from './vulcanHelpers/additionalCustomerInformationHelpers';
import stringInterpolation from '../utils/stringInterpolation';
import { SecureBusinessHelpers } from './vulcanHelpers/secureBusinessHelpers';
import RedeemOfferVulcan from './vulcanHelpers/couponCode/RedeemOfferVulcan';
import BusinessOptikTvTable from './vulcanHelpers/businessOptikTv';
import OfficePhoneLine from './vulcanHelpers/officePhone';
import {
  fibreSpeed,
  offers,
  fieldInstallation,
  fieldServiceAddressNoteFibreVul
} from './vulcanPricing/fibeInternet/fibreInternetFieldNames';
import FibreInternet from './vulcanHelpers/fibreInternet';
import CopperInternet from './vulcanHelpers/copperInternet';
import TsbConsolidation from './vulcanHelpers/consolidationTSB';
import filterProduct from './vulcanHelpers/customerSection/filterProduct';
import { getDropdownPricingFromValue } from './vulcanHelpers/tsbSection/utils';
import { getInstallationFeePaymentType } from './vulcanPricing/utils/utils';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const equipmentGroupSectionKey = 'equipmentGroupSection';
const typeMultiCheckbox = 'MultiCheckbox';
const formSectionTitle = 'formSectionTitle';
const profile = request.getProfile();

const initialEquipmentPrices = {
  subtractAmountFromPrice: 0,
  addAmountToPrice: 0,
  addAmountToMonthly: 0,
  subtractAmountFromMonthly: 0
};

const FormStepVulcan = ({
  stepData = null,
  steps,
  step,
  setFormRef = null,
  onFormSubmit = null,
  orderData = {},
  hideProgressBar = false,
  isEditing,
  formName,
  onSaveAndExit = () => {},
  updateStep = () => {},
  history,
  setOrderData = () => {},
  isCreateOrderButtonVisible,
  stepDataForSummary
}) => {
  if (!stepData) return null;
  const translations = useTranslationsContext();
  const locale = useLocaleContext();

  const {
    formStep: { errorMessageInc },
    vulcanWebform: {
      yes,
      vulBusinessConnect,
      vulBusinessPersonalOption,
      vulAccountDetails,
      vulThreeMonthsFreeTSB,
      vulWaivedInstallationFeeOptionTSB,
      vulDiscountForInstallationFeeOptionTSB,
      commercial,
      vulTenDollarBundleDiscountTSB,
      vulFifteenDollarMonthlyDiscountTSB,
      vulMonitorTSB,
      vulProtectTSB,
      vulSmartCameraTSB,
      vulHundredDollarInstallationFee,
      vulAccessPointsAlert,
      vulInternetBackup
    }
  } = locale === 'en-US' ? EN : FR;
  const {
    KEYS: {
      CHANNELS: { CORP_STORE, DEALER }
    }
  } = CONSTANT;
  const {
    contentfulValues: { valueEnglish, valueFrench },
    summaryForm: { summaryLabel }
  } = translations;
  const {
    fields: {
      name: formStepName,
      backendKey: formStepBackendKey,
      formStepFields,
      modalForms
    }
  } = stepData;
  const formStepRef = createRef();
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [formFieldsCopy, setFormFieldsCopy] = useState({});
  const [formFieldsForSummary, setFormFieldsForSummary] = useState({});
  const [businessOptikTvTableData, setBusinessOptikTvTableData] = useState(
    null
  );
  const [officePhoneLinesData, setOfficePhoneLinesData] = useState([]);
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [showDownloadQuoteFooter, setShowDownloadQuoteFooter] = useState(false);
  const quotePdf = useOrderPdf();
  const [resetSection, setResetSection] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalOpenValidation, setModalOpenValidation] = useState(false);
  const [modalTextValidation, setModalTextValidation] = useState('');
  const { role, channel } = (typeof profile !== 'undefined' && profile) || {};
  const [renderTempSensor, setRenderTempSensor] = useState(false);
  const [equipmentTotalPrice, setEquipmentTotalPrice] = useState(
    initialEquipmentPrices
  );
  const [hardwareDiscountAmount, setHadwareDiscountAmount] = useState(0);
  const [isHardwareDiscount, setIsHardwareDiscount] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [redeemOfferData, setRedeemOfferData] = useState({});
  const [fibreInternetData, setFibreInternetData] = useState(productCatalog);
  const [copperInternetData, setCopperInternetData] = useState(productCatalog);
  const [tsbData, setTsbData] = useState(productCatalog);
  const channelName = channel && channel.name;
  const [isFieldReset, setIsFieldReset] = useState(false);
  const dealershipName = _.get(orderData, 'orderCreatedBy.Dealership.name');

  const getDefaultValue = (key, value) => {
    if (isEditing && orderData) return orderData[key];
    return value || '';
  };

  // Stage 4c-iv: ported off the legacy `formFields` bag onto the engine's own
  // `values` — `addProductVulcan`/`webFormOrderId` are ordinary step-1 leaf
  // fields, tracked normally in `engine.values` (equipment sections are also
  // sourced off the engine now — see `buildEngineFieldBag`).
  const validatedForOrderId = async engine => {
    if (
      step === 1 &&
      engine.values[fieldAddProductVulcan] &&
      engine.values[fieldAddProductVulcan].includes(vulBusinessConnect)
    ) {
      try {
        await request.get(
          `/orders/validation/sof?webFormOrderId=${engine.values[fieldWebFormOrderId]}`
        );
        return false;
      } catch (error) {
        setModalTextValidation(error.response.data.error.message);
        setModalOpenValidation(true);
        return true;
      }
    }
    return false;
  };

  const normalizedFields = (data, initFields, isDefaultRequired) => {
    let result = initFields;
    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          threeYearEasyPayment,
          fiveYearEasyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          customFieldErrorMessage,
          oneTimePrice,
          resetFields,
          customResetFields,
          label
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();
        let data1;
        if (Array.isArray(fields.formStepFields && fields.easyPaymentFields)) {
          data1 = [...fields.formStepFields, ...fields.easyPaymentFields];
        } else if (
          Array.isArray(fields.oneTimePaymentFields) &&
          Array.isArray(fields.threeYearEasyPaymentFields) &&
          Array.isArray(fields.fiveYearEasyPaymentFields)
        ) {
          data1 = [
            ...fields.oneTimePaymentFields,
            ...fields.threeYearEasyPaymentFields,
            ...fields.fiveYearEasyPaymentFields
          ];
        } else {
          data1 = fields.formStepFields;
        }
        const equipmentGroupData = { data: data1, isEditing, orderData, key };

        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result, isDefaultRequired);
        } else if (id === formSection) {
          result = normalizedFields(
            fields.formFields,
            result,
            isDefaultRequired
          );
        } else if (id === userDetailsKey) {
          result = normalizedFields(
            fields.formStepFields,
            result,
            isDefaultRequired
          );
        } else if (id === equipmentGroupSectionKey) {
          const formObjectKeys = normalizeEquipmentGroupSection(
            equipmentGroupData
          );
          result[key] = formObjectKeys;
        } else if (id === repeatedFormKey) {
          const formObjectKeys = fields.formFields.reduce(
            (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
              acc[formNameKey] = defaultValue;
              return acc;
            },
            {}
          );
          result[fields.key] = [formObjectKeys];
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          let defaultValue = !isDefaultRequired
            ? getDefaultValue(key, value)
            : '';
          let updatedMonthlyPayment = monthlyPayment;
          let updatedPrice = price;
          let updatedOneTimePrice = oneTimePrice;
          let updatedThreeYearEasyPayment = threeYearEasyPayment;
          let updatedFiveYearEasyPayment = fiveYearEasyPayment;

          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );
              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
                updatedOneTimePrice = currentOption.fields.oneTimePrice;
                updatedThreeYearEasyPayment =
                  currentOption.fields.threeYearEasyPayment;
                updatedFiveYearEasyPayment =
                  currentOption.fields.fiveYearEasyPayment;
              }
            }
          }
          if (type === typeMultiCheckbox) {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
            }
          }
          /**
           * Condition to select default activation lagnguage
           * based on the curren locale
           */
          if (key === fieldActivationLanguage) {
            const currentLocale = getPathVariables(window.location.pathname)[0];
            defaultValue =
              currentLocale === localeFr ? valueFrench : valueEnglish;
          }
          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            initOneTimePrice: updatedOneTimePrice || 0,
            oneTimePrice: updatedOneTimePrice || 0,
            initThreeYearEasyPayment: updatedThreeYearEasyPayment || 0,
            threeYearEasyPayment: updatedThreeYearEasyPayment || 0,
            initFiveYearEasyPayment: updatedFiveYearEasyPayment || 0,
            fiveYearEasyPayment: updatedFiveYearEasyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField,
            customFieldErrorMessage,
            fieldLabel: label
          };
          if (resetFields) {
            result[key].resetFields = resetFields;
          }

          if (customResetFields) {
            result[key].customResetFields = customResetFields;
          }
          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }
          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
      });
    }
    return result;
  };

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;
    return id === formSection;
  });

  const getHiddenSections = fields => {
    const hiddenSections = [];
    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (
        !isRelatedFieldExisted(section.fields, fields, orderData, isFormTouched)
      ) {
        hiddenSections.push(sectionName);
      }
    });
    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  useEffect(() => {
    if (
      (!isEditing && formStepFields) ||
      (isEditing && orderData && orderData.id && !isFieldReset)
    ) {
      // Stage 4c-iv-b: `formFields` (the legacy payload-building bag) is
      // gone — the submit payload is built off the engine directly (see
      // `buildEngineFieldBag`). `updatedFields` is now purely a LOCAL
      // computation: the TSB-15 dropdown-pricing rehydration below and the
      // Business Optik TV restoration further down still need it, neither
      // of which has an engine-native replacement, but nothing persists it
      // to state anymore.
      let updatedFields = normalizedFields(formStepFields, {});
      if (stepDataForSummary) {
        const updatedFieldsForSummary = normalizedFields(
          stepDataForSummary.fields.formStepFields,
          formFieldsForSummary,
          true
        );
        const updatedFieldsCopy = normalizedFields(
          formStepFields,
          formFieldsCopy
        );
        setFormFieldsForSummary(updatedFieldsForSummary);
        setFormFieldsCopy(updatedFieldsCopy);
      }

      if (
        orderData &&
        orderData.id &&
        tsb15SectionPriceKeys.some(sk => orderData[sk])
      ) {
        updatedFields = { ...updatedFields };
        tsb15SectionPriceKeys.forEach(sectionKey => {
          if (orderData[sectionKey] && updatedFields[sectionKey]) {
            updatedFields[sectionKey] = { ...updatedFields[sectionKey] };
            Object.keys(orderData[sectionKey]).forEach(fieldKey => {
              if (!fieldKey.includes('_dropdown')) return;
              const baseFieldName = fieldKey.replace('_dropdown', '');
              const orderField = orderData[sectionKey][fieldKey];
              const formField = updatedFields[sectionKey][baseFieldName];
              if (!orderField || !formField) return;
              const dropdownValue = orderField;
              const options = formField.dropdownOptions || [];
              const pricing = getDropdownPricingFromValue(
                dropdownValue,
                options
              );
              updatedFields[sectionKey][baseFieldName] = {
                ...formField,
                ...pricing,
                dropdownValue
              };
            });
          }
        });
      }

      // Restore Business Optik TV table data from orderData
      if (orderData && orderData.id) {
        // Find the Business Optik TV table field and restore its data
        const businessOptikTvField = Object.keys(updatedFields).find(
          key =>
            updatedFields[key] && updatedFields[key].type === 'OptikTvTable'
        );

        if (businessOptikTvField && updatedFields[businessOptikTvField].value) {
          setBusinessOptikTvTableData(
            updatedFields[businessOptikTvField].value
          );
        }

        // Restore Office Phone Lines data from orderData
        if (
          orderData.officePhoneLinesData &&
          Array.isArray(orderData.officePhoneLinesData)
        ) {
          setOfficePhoneLinesData(orderData.officePhoneLinesData);
        }

        if (orderData.fibreInternetData) {
          setFibreInternetData(orderData.fibreInternetData);
        }

        if (orderData.copperInternetData) {
          setCopperInternetData(orderData.copperInternetData);
        }

        if (orderData.tsbData) {
          setTsbData(orderData.tsbData);
        }
      }

      updateSections(getHiddenSections(updatedFields));
      setIsLoading(false);
      setIsFormTouched(false);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData, locale, resetSection]);

  const prevStep = e => {
    e.preventDefault();
    setFormErrors({});
    setIsLoading(true);
    if (orderData.addProductVulcan.includes(vulBusinessConnect) && step === 3) {
      // remove steps from here
      updateStep(step - 2);
    } else if (orderData && orderData.orderIdTSB && step === 3) {
      updateStep(step - 2);
    } else {
      updateStep(step - 1);
    }

    history.push({
      pathname: `/${locale}/${categoryVulcan}/${vulcanForm}`,
      search: `?orderId=${orderData.id}&step=${step - 1}&isEditing=true`
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  // Guard against mounting the harness with a STALE/incomplete `orderData`
  // snapshot. `orderData` is fetched ASYNCHRONOUSLY by the parent Form
  // component (starts `undefined`, populated later via
  // `setOrderData(response.data)`) — but `useFormRunner`'s `values` state is a
  // ONE-TIME initialization from `initialValues` at MOUNT, with no reactive
  // re-sync if the prop updates afterward. The real app's own field
  // population (`normalizedFields`) instead runs inside a `useEffect`
  // watching `[formStepFields, orderData, …]`, so it re-populates every time
  // `orderData` changes — the harness has no equivalent for PLAIN leaf
  // fields. (userDetails-section fields WERE populating correctly regardless,
  // because UserDetailsForm has its own `useEffect(…, [isEditing, orderData])`
  // that re-populates reactively — the harness doesn't undermine that.)
  // Confirmed real-data bug: legalBusinessName/tradeName/incorporationNumber/
  // incorporationDate showed blank under `?fce=1` (mounted while `orderData`
  // was still `{}`) but populated under `?fce=0`. Fix: don't mount the
  // harness in edit mode until `orderData.id` is actually present — matching
  // the real form's own `isLoading` gate.
  if (isEditing && !(orderData && orderData.id)) {
    return (
      <div ref={formStepRef}>
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      </div>
    );
  }

  // Chromeless composition (forms-core alpha.6): reuse formStepVulcan's REAL
  // chrome — the card `<Box>`, the real `VulcanStatusBar` footer computed via
  // the real `vulcanPricing()` (fed by the engine's rich state, matching the
  // pricingAdapter's own `fields = formFields || fieldStates` convention), and
  // real Back navigation — around the engine's field/section tree. This is what
  // removes the visual diffs (no card, placeholder $0.00 footer, plain Submit
  // button) the whole-chrome preview had.
  //
  // Continue / Save are wired for REAL here, with ENGINE-NATIVE validation.
  //
  // The app's `nextStep`/`saveAndExit` can't be reused as-is: both build their
  // payload with `getFormData(formFields, …)` from a legacy bag (`formFields`
  // was removed in Stage 4c-iv-b; the `normalizedFields` effect above still
  // runs, but only for `formFieldsCopy`/`formFieldsForSummary` now — see that
  // effect's own comment), and `nextStep` additionally validates it with
  // `getErrors(formStepFields, formErrors)`. Historically that legacy bag was
  // populated here with only INITIAL values; the user's edits live in engine
  // state, so validating or
  // submitting from it would silently use stale data.
  //
  // So each is reproduced with the engine as the source of truth:
  //   - validation → `engine.goNext()`, which validates the current step,
  //     reveals errors, and returns false when invalid. The definition is
  //     single-step, so `isLastStep` is true and it never self-advances —
  //     it acts purely as validate+reveal, leaving navigation to the app.
  //   - payload → the same `getFormData(...)` call, fed a field bag built
  //     directly from the engine (see `buildEngineFieldBag`) plus the
  //     ancillary blobs from `engine.values`.
  //   - persistence/navigation → the app's own `onFormSubmit` / `onSaveAndExit`
  //     / `validatedForOrderId`, unchanged.
  //
  // NOTE: engine validation covers the declarative rules (required +
  // `fieldValidation`); it is not guaranteed to be a superset of every check
  // `getErrors` performs, so watch for validation gaps when testing.
  //
  // `onBackClick={prevStep}` is the app's own: pure navigation (history +
  // updateStep), no validation or persistence.
  // The payload path needs a bag with the LEGACY shape and FULL coverage:
  // `getFormData` -> `getFormFieldSummary` reasons over the whole ORDER (every
  // step's fields, and entries it can read `.value`/`.type` off). Stage
  // 4c-iv-a: `VulcanFormStepRunner` now builds a multi-step `definition`, so
  // `engine.fieldStates` already covers the WHOLE order on its own — no
  // longer single-step, no longer needing the legacy `formFields` bag as a
  // completeness/shape fallback. `buildEngineFieldBag` builds that bag
  // directly from the engine (fieldStates + the equipment blobs and
  // never-tree-walked writes `fieldStates` doesn't carry) — see its own
  // doc comment for the full breakdown. `formFields` (the legacy bag) is no
  // longer read here at all.
  const buildEngineFormData = engine => {
    // `formFieldsCopy` is a separate, otherwise-static snapshot (populated
    // once by `normalizedFields`) that `getFormFieldSummary` reads to decide
    // whether the alternate-language (French) quote should include the
    // equipment-count-driven installation-fee discount — it never runs
    // fieldRules itself, so without this it never sees the discount option
    // and silently drops that row from the French summary. Faithful port of
    // formStepVulcan.js's legacy render loop, which called
    // `handleInstallationFeeDiscount` a THIRD time directly on
    // `formFieldsCopy[secureBusinessOffersVulcan]` for the same reason.
    //
    // This must apply the EXACT SAME remove-waived/append-percentage
    // transform `handleInstallationFeeDiscount` does — not just copy over the
    // engine's fully plan-filtered/disabled options — because
    // `getFormFieldSummary`'s index-aligned mirroring assumes
    // `formFieldsCopy[key].options` and `formFieldsForSummary[key].options`
    // (the alternate-locale snapshot, never touched by fieldRules) start from
    // the SAME base list. Replacing it wholesale desynced the two arrays and
    // mislabelled the discount as a different offer (e.g. TSBPROTECT5OFF60)
    // in the French summary.
    const offersField = formFieldsCopy[secureBusinessOffersVulcan];
    const plan = engine.values[secureBusinessPlanVulcan];
    // Guard on a selected plan — matches `makeSecureBusinessRule`'s own
    // `if (!plan) return undefined;` gate. Without it this ran on EVERY
    // Continue regardless of whether Secure Business was ever selected,
    // unconditionally stripping the Waived-Installation-Fee option out of
    // `formFieldsCopy` while leaving `formFieldsForSummary` untouched —
    // desyncing the two arrays and crashing `getFormFieldSummary`'s
    // index-aligned lookup ("Cannot read properties of undefined (reading
    // 'fields')") on a plain Continue from step 1.
    if (offersField && plan) {
      const fieldBag = buildEngineFieldBag(engine);
      const additionalEquipmentKeyByPlan = {
        [vulMonitorTSB]: keyMonitorAdditionalEquipmentVulcan,
        [vulProtectTSB]: keyProtectAdditionalEquipmentVulcan,
        [vulSmartCameraTSB]: smartCameraAdditionalEquipmentVulcan
      };
      const equipmentKey = additionalEquipmentKeyByPlan[plan];
      const numberOfSelectedAdditionalEquipments =
        (equipmentKey
          ? numberOfSelectedItems(engine.values[equipmentKey])
          : 0) +
        getTsb15AddOnEquipmentCount(fieldBag, {
          ...orderData,
          salesRepOutlet:
            profile && profile.outlet ? profile.outlet.toString() : ''
        });
      const isPercentageDiscount = [
        vulMonitorTSB,
        vulProtectTSB,
        vulSmartCameraTSB
      ].includes(plan);
      handleInstallationFeeDiscount(
        offersField,
        numberOfSelectedAdditionalEquipments,
        isPercentageDiscount,
        engine.values[fieldInstallationFeePaymentOption],
        engine.values[fieldInstallationFeeAmount]
      );
    }
    return getFormData(
      buildEngineFieldBag(engine),
      step,
      formFieldsForSummary,
      formFieldsCopy,
      engine.values.redeemOfferData || {},
      {
        ...orderData,
        salesRepOutlet:
          profile && profile.outlet ? profile.outlet.toString() : ''
      },
      engine.values.businessOptikTvTableData ?? null,
      engine.values.officePhoneLinesData || [],
      engine.values.fibreInternetData || productCatalog,
      engine.values.copperInternetData || productCatalog,
      engine.values.tsbData || productCatalog
    );
  };

  const handleEngineProceed = async (engine, e) => {
    if (e && e.preventDefault) e.preventDefault();
    // Engine-native validation: bails and reveals field errors when invalid.
    if (!engine.goNext()) return;
    const validatedOrderIdOfBusinessConnect = await validatedForOrderId(engine);
    if (validatedOrderIdOfBusinessConnect) return;
    const shouldShowDownloadQuote =
      formName !== vulcanLandingPage && !showDownloadQuoteFooter && step === 1;
    const fields = buildEngineFormData(engine);
    // Per upstream (a84163ef): isVulcanOrder/province qualification only ever
    // happens on the landing page (step 1) — recompute only there so a later
    // step's proceed never overwrites the already-correct persisted flag.
    if (step === 1 && engine.values[fieldProvinceVUL]) {
      fields.isThisVulcanOrder = computeIsThisVulcanOrder(engine.values, yes);
    }
    // Reveal "Download Quote" only AFTER the save round-trips to the server —
    // clicking it while the save is still in flight can read stale/incomplete
    // order data and produce an empty quote PDF (QA-reported race).
    // The landing page is a single step, but its "New Order" is never the
    // order's last step — only Vulcan_Form's Order Summary may submit.
    await onFormSubmit(
      fields,
      !shouldShowDownloadQuote,
      formName !== vulcanLandingPage && step === steps.length
    );
    setShowDownloadQuoteFooter(shouldShowDownloadQuote);
  };

  const handleEngineSaveAndExit = async engine => {
    // Parity with saveAndExit: no validation, just persist what's there.
    const fields = buildEngineFormData(engine);
    if (!Object.entries(fields).length) return;
    const validatedOrderIdOfBusinessConnect = await validatedForOrderId(engine);
    if (validatedOrderIdOfBusinessConnect) return;
    onSaveAndExit(fields);
  };
  //
  // VulcanStatusBar is `position: fixed`, pinned to the viewport bottom. In the
  // real (non-preview) render it's a direct sibling near the TOP of
  // formStepVulcan's own tree; here it's several levels deeper (nested inside
  // VulcanFormStepRunner's <ExpandCollapse> + the package's renderChrome call),
  // and that extra nesting was letting the app's normal-flow page footer
  // (Layout > Footer, "© … TELUS Communications Inc.") bleed through/overlap
  // it. Rendering it via a PORTAL straight to `document.body` makes it a
  // structurally independent, last-in-body DOM node again — sidestepping any
  // nesting-based stacking/containing-block issue regardless of exact cause,
  // and matching how the real form's status bar behaves. Preview-scoped only;
  // the real (?fce=0) render is untouched.
  const formCard = body => (
    <Box
      style={{
        border: '1px solid #e3e3e3',
        boxShadow: '1px 1px 9px 4px #e3e3e3',
        padding: '2rem',
        marginBottom: '1rem',
        marginLeft: '4rem',
        marginRight: '4rem'
      }}
    >
      {/* style.css pads `.expand > div > div > div > div > div > div` (the TDS
          ExpandCollapse panel content) by 1rem. Legacy rendered
          `.expand > ExpandCollapse > Panel`; the engine mounts ExpandCollapse
          above this card, so without this extra level that selector lands one
          depth lower — on every field wrapper — and doubles the field spacing. */}
      <div className="expand">
        <div>{body}</div>
      </div>
    </Box>
  );

  const renderVulcanChrome = (engine, body) => (
    <>
      {/* The <form> is load-bearing, not decoration: TDS submit Buttons call
          `form.requestSubmit()`, and the PARENT holds this node via setFormRef
          and calls `formRef.current.requestSubmit()` itself
          (form/index.js:1180). Without it both paths hit
          `Cannot read properties of null (reading 'requestSubmit')` — which is
          what broke "New Order". */}
      <form
        name={formStepName}
        onSubmit={e => handleEngineProceed(engine, e)}
        ref={ref => setFormRef && setFormRef(ref)}
      >
        {/* Layout parity: the landing page (and any step with no sections) wraps
          the card in a fixed-width column; every other step renders the card
          directly. Dropping that wrapper is what pushed "New Order" beside its
          section instead of under it. */}
        {sections.length && formStepName !== isVulcanLandingPage ? (
          formCard(body)
        ) : (
          <div style={{ width: '1000px' }}>{formCard(body)}</div>
        )}
        {/* Alert modals lived in the render path that Stage 4a deleted.
          `validatedForOrderId` drives the validation one — it blocks
          Continue/Save on a BusinessConnect failure, so without this the submit
          silently does nothing with no explanation. The access-points alert is
          driven by the `onUserEdit` guard below. */}
        <Modal
          heading="Alert"
          bodyText={modalText}
          onClose={() => setModalOpen(false)}
          isOpen={modalOpen}
        />
        <Modal
          heading="Alert"
          bodyText={modalTextValidation}
          onClose={() => setModalOpenValidation(false)}
          isOpen={modalOpenValidation}
        />
      </form>
      {formName === vulcanForm &&
        ReactDOM.createPortal(
          <VulcanStatusBar
            step={step}
            isLastStep={steps.length === step}
            isFormTouched={isFormTouched || isFieldReset}
            totals={vulcanPricing(
              engine.fieldStates,
              {
                ...orderData,
                salesRepOutlet:
                  profile && profile.outlet ? profile.outlet.toString() : ''
              },
              engine.values.redeemOfferData || {},
              engine.values.businessOptikTvTableData ?? null,
              engine.values.officePhoneLinesData || [],
              engine.values.fibreInternetData || productCatalog,
              engine.values.copperInternetData || productCatalog,
              engine.values.tsbData || productCatalog,
              // Equipment sections are `custom`/blob-shaped in the engine —
              // never tree-walked into fieldStates — so getSecureBusinessTotals
              // needs each plan's equipment data passed explicitly, same as
              // the other ancillary blobs above.
              secureBusinessSectionsVulcan.reduce((acc, key) => {
                if (engine.values[key]) acc[key] = engine.values[key];
                return acc;
              }, {})
            )}
            onBackClick={prevStep}
            onProceedClick={e => handleEngineProceed(engine, e)}
            onSaveAndExit={() => handleEngineSaveAndExit(engine)}
            showDownloadQuoteFooter={showDownloadQuoteFooter}
            onQuoteDownload={() =>
              quotePdf.openPdf({
                orderId: orderData.id,
                route: `${apiHost}/orders/${orderData.id}/customer-quote-pdf?lang=${locale}`
              })
            }
            quotePdfStatus={quotePdf.status}
          />,
          document.body
        )}
    </>
  );

  return (
    <div ref={formStepRef}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={steps}
          currentStep={step}
          locale={locale}
          formName={formName}
        />
      )}
      <div />
      {isLoading ? (
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      ) : (
        <FormsCorePreviewBoundary>
          <VulcanFormStepRunner
            stepFields={formStepFields}
            stepName={formStepName}
            step={step}
            // Stage 4c-ii: every step's Contentful data, not just the
            // current one — lets VulcanFormStepRunner build an engine
            // `definition` spanning the WHOLE order, so `fieldStates`
            // doesn't forget an already-visited step's fields on submit
            // (findings #19-#21).
            steps={steps}
            orderData={orderData}
            profile={profile}
            locale={locale}
            // fieldRules/sections read option-value copy (e.g. businessOptikTv)
            // from the STATIC EN/FR JSON by locale — NOT the Contentful
            // translations context, which lacks those keys (matches the original
            // vulcanHelpers, which import EN/FR directly).
            strings={(locale === 'en-US' ? EN : FR).vulcanWebform}
            dealershipName={dealershipName}
            initialValues={orderData}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            setShowDownloadQuoteFooter={setShowDownloadQuoteFooter}
            roleLabels={roleLabels}
            role={role}
            formStepBackendKey={formStepBackendKey}
            stepKeyMain={stepKeyMain}
            localeFrench={localeFrench}
            renderChrome={renderVulcanChrome}
            // Parity of handleFormField's touched side effect
            // (formStepVulcan.js:1238) for engine-driven field edits, which
            // otherwise never reach this component — leaving isFormTouched
            // false so "Save and Continue later" (disabled={!isFormTouched})
            // never enabled. Bespoke sections already report this themselves via
            // setIsFormTouched, so this covers the plain leaf fields.
            onUserEdit={(name, value) => {
              if (!isFormTouched) {
                setIsFormTouched(true);
                setShowDownloadQuoteFooter(false);
              }
              // Parity of handleFormField's access-points guard
              // (qa-v2 formStepVulcan.js:1351): going past the max alerts and
              // discards the write, so the counter stays at the limit.
              if (
                name === fieldNumberOfAccessPoints &&
                Number(value) > numberOfAccessPointsTotal
              ) {
                setModalText(vulAccessPointsAlert);
                setModalOpen(true);
                return false;
              }
              return true;
            }}
            // Parity of formStepVulcan.js's formSection panel body
            // (`{step === 4 && <VulcanOrderSummary .../>}`), rendered inside
            // EVERY collapsible section on step 4 — not gated by section name,
            // matching the original exactly. Without this, step 4 (Order
            // Summary) has no real content: this was the actual gap the
            // "MultiFileUpload" placeholder had been masking.
            renderSectionExtras={() =>
              step === 4 ? (
                <VulcanOrderSummary stepData={steps} orderData={orderData} />
              ) : null
            }
          />
        </FormsCorePreviewBoundary>
      )}
    </div>
  );
};

FormStepVulcan.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      formStepFields: PropTypes.arrayOf(PropTypes.shape({})),
      showTotal: PropTypes.bool,
      modalForms: PropTypes.arrayOf(PropTypes.shape({})),
      backendKey: PropTypes.string
    })
  }),
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setFormRef: PropTypes.func,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  setOrderData: PropTypes.func,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    productSelectionFM: PropTypes.arrayOf(PropTypes.string),
    managedItServicesData: PropTypes.shape({}),
    microsoftLicensingData: PropTypes.shape({
      adjustedTotalPrice: PropTypes.number
    }),
    managedItServicesSummary: PropTypes.shape({
      totalMonthlyCharges: PropTypes.number,
      totalOneTimeCharges: PropTypes.number
    })
  }),
  hideProgressBar: PropTypes.bool,
  isEditing: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  isCreateOrderButtonVisible: PropTypes.bool,
  stepDataForSummary: PropTypes.shape({
    fields: PropTypes.shape({
      formStepFields: PropTypes.arrayOf(PropTypes.shape({}))
    })
  })
};

export default FormStepVulcan;
